"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  orientation: _propTypes2.default.oneOf(['vertical', 'horizontal'])
};

var Divider = function Divider(props) {
  var _size;

  var size = (_size = {}, _size[props.orientation === 'horizontal' ? 'height' : 'width'] = 1, _size);
  return _react2.default.createElement("div", {
    className: "bg-light-gray",
    style: size
  });
};

Divider.propTypes = propTypes;
Divider.defaultProps = {
  orientation: 'horizontal'
};
exports.default = Divider;